import Embed from 'quill/blots/embed';

import { QuillVariable, QuillVariableType } from './variableToolbar.quillModule';

export const VARIABLE_BLOT_NAME = 'variable';

export class VariableBlot extends Embed {
  static blotName = VARIABLE_BLOT_NAME;
  static tagName = 'span';
  static className = 'variable-blot';

  static create(data: QuillVariable) {
    const node = super.create(data) as HTMLElement;

    if (!data?.dataKey) {
      console.warn('Ignoring pasted content without a variable key');
      return node; // Prevent inserting empty variable blots
    }

    node.setAttribute('class', 'chip');
    node.setAttribute('data-title', data.title);
    node.setAttribute('data-key', data.dataKey);
    node.setAttribute('data-type', data.dataType);
    node.setAttribute('data-format', data.format);
    node.setAttribute('data-value', data.value);
    node.setAttribute('data-color', data.color);
    node.setAttribute('data-variable-blot', 'true'); // Mark for clipboard

    // Apply styling (background color from definition)
    node.style.backgroundColor = data.color;
    node.style.padding = '2px 6px';
    node.style.borderRadius = '4px';
    node.style.fontSize = '0.9em';
    node.style.fontWeight = 'bold';

    // Ensure readable text color
    node.style.color = VariableBlot.getReadableTextColor(data.color);

    const hasValue = data.value !== undefined && data.value !== null && data.value !== '';

    // Set content inside the editor
    if (hasValue) {
        const formattedValue = VariableBlot.formatValue(data.value, data.dataType, data.format);
        node.innerText = formattedValue;
        node.setAttribute('title', data.title); // show variable name on hover
    } else {
        node.innerText = `#${data.title}`; // show variable name as placeholder
    }

    // node.innerHTML = `${data.title}: VariableBlot.formatValue(data.value, data.dataType, data.format)}`;

    return node;
  }

  static value(node: HTMLElement): QuillVariable {
    return {
      title: node.getAttribute('data-title') || '',
      dataKey: node.getAttribute('data-key') || '',
      dataType: node.getAttribute('data-type') as QuillVariableType,
      format: node.getAttribute('data-format') || '',
      value: node.getAttribute('data-value') || '',
      color: node.getAttribute('data-color') || '#d1d1d1',
    };
  }

  public static formatValue(value: any, type: string, format: string): string {
    if (!value) return '';

    if (type === QuillVariableType.CURRENCY) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(value);
    }
    if (type === QuillVariableType.DATE && format) {
      return new Date(value * 1000).toLocaleDateString('en-US', {
        dateStyle: format as Intl.DateTimeFormatOptions['dateStyle'],
      });
    }
    return value?.toString() || '';
  }

  public static getReadableTextColor(bgColor: string): string {
    const rgb = parseInt(bgColor.slice(1), 16);
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = rgb & 0xff;

    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? '#000000' : '#ffffff';
  }
}
